import { InfiniteSlider } from "@/components/ui/infinite-slider";
import { cn } from "@/lib/utils";

type Logo = {
  src: string;
  alt: string;
  width?: number;
  height?: number;
};

type LogoCloudProps = React.ComponentProps<"div"> & {
  logos: Logo[];
};

export function LogoCloud({ className, logos, ...props }: LogoCloudProps) {
  return (
    <div className={cn("w-full", className)} {...props}>
      <InfiniteSlider gap={48} duration={30} durationOnHover={60}>
        {logos.map((logo) => (
          <img
            key={logo.alt}
            src={logo.src}
            alt={logo.alt}
            loading="lazy"
            decoding="async"
            width={logo.width || 112}
            height={logo.height || 32}
            className="h-8 w-28 object-contain brightness-0 dark:brightness-0 dark:invert"
          />
        ))}
      </InfiniteSlider>
    </div>
  );
}
